import axios from "axios";
import Sweetalert from "./SweetAlerts";
import { useDispatch } from "react-redux";
import { store } from "../store";
import { config } from "./CommonURLS";
import qs from "qs";
export const CommonAjaxGetRequestWithOutParams = async (url) => {
  let res = "";
  var token = JSON.parse(localStorage.getItem("token"));
  // var token = await getTokenFromLocalStorage('token')
  try {
    res = await axios({
      url: url,
      method: "get",
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
    }
    return res.data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosPostLoginDb = async (url, values) => {
  let data = "";
  try {
    //var token = JSON.parse(localStorage.getItem("token"));
    let res = await axios({
      // baseURL: config.url.LOGIN_API__URL,
      url: url,
      method: "post",
      data: values,
      //headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    //catchErrorMessages(err)

    if (err.response && err.response.status === 401) {
      data = err.response;
    }

    return data;
  }
};

export const CommonAxiosGetdb = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse('"' + localStorage.getItem("token") + '"');
  try {
    let data = "";
    let res = await axios({
      //baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetwithPayload = async (url, values) => {
  try {
    let data = "";
    //var token = JSON.parse(localStorage.getItem("token"));
    var token = JSON.parse('"' + localStorage.getItem("token") + '"');
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGet = async (url, values) => {
  var token = JSON.parse(localStorage.getItem("token"));
  // var token = await getTokenFromLocalStorage('token')
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};


export const CommonAxiosGetWithoutToken = async (url, values, responseType) => {
  try {
    const res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      responseType: responseType || "json", // "json" is the default, so old calls work as before
    });

    if (res.status === 200) {
      return res;
    }

    return "";
  } catch (err) {
    catchErrorMessages(err);
    return "";
  }
};

export const CommonAxiosGetMeetings = async (url, values) => {
  var token = JSON.parse(localStorage.getItem("token"));
  // var token = await getTokenFromLocalStorage('token')
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL_MEETINGS,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetLogin = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse('"' + localStorage.getItem("token") + '"');
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL_LOGIN,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetPdf = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse(localStorage.getItem("token"));
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/pdf", // Set the expected Content-Type
      },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetPdfWithoutToken = async (url, values) => {
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      responseType: "arraybuffer",
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetu = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse('"' + localStorage.getItem("token") + '"');
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};
export const CommonAxiosPostu = async (url, values) => {
  try {
    let data = "";
    //var token = JSON.parse(localStorage.getItem("token"));
    var token = JSON.parse('"' + localStorage.getItem("token") + '"');
    let res = await axios({
      baseURL: config.url.API_URL_U,
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetService = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse('"' + localStorage.getItem("token") + '"');
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL_SERVICE,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};
export const CommonAxiosPost = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosPostMeetings = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL_MEETINGS,
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosPostDMS = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: "https://api.swarnapanchayat.apcfss.in/panchayatrajdms/",
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosPut = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "put",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosDelete = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "delete",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};
export const CommonAjaxPostWithFileUpload = async (url, values) => {
  let res = "";
  //var token = JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse(localStorage.getItem("token"));
  try {
    res = await axios({
      url: url,
      method: "post",
      async: false,
      contentType: false,
      processData: false,
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
    }
    return res;
  } catch (err) {
    catchErrorMessages(err);
  }
};
export const CommonAxiosPostLogin = async (url, values) => {
  let data = "";
  try {
    //var token = JSON.parse(localStorage.getItem("token"));
    let res = await axios({
      baseURL: config.url.AUTHENTICATION_URL,
      url: url,
      method: "post",
      data: values,
      //headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    //catchErrorMessages(err)

    if (err.response && err.response.status === 401) {
      data = err.response;
    }

    return data;
  }
};
export const CommonAjaxPostLoginRequest = async (url, values) => {
  let res = "";
  try {
    res = await axios({
      url: url,
      method: "post",
      data: values,
    });
    if (res.status === 200) {
    }
    return res.data;
  } catch (err) { }
};

export const CommonAxiosGetjnbservicesapi = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
  try {
    let data = "";
    let res = await axios({
      // baseURL: config.url.API_URL_U,
      url: url,
      method: "get",
      // data: values,
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

const KillToken = () => {
  let refreshToken = JSON.parse(localStorage.getItem("refresh_token"));
  const payload = { refresh_token: refreshToken };

  CommonAxiosPost("killtoken", payload)
    .then((response) => { })
    .catch((error) => {
      console.error("Error killing token:", error);
    });
};

const catchErrorMessages = (err) => {
  //  const dispatch = useDispatch();

  const { dispatch } = store;
  if (err?.response?.status === 401) {
    //|| err?.response?.status === 400

    KillToken();

    Sweetalert("UnAuthorised Access!.", "error").then(function () {
      window.location.href = "/loginpage/main";
    });

    setTimeout(() => {
      dispatch({ type: "HIDE_SPINNER" });
    }, 25000);
  } else if (err?.response?.status === 404) {
    Sweetalert("Data Not Found!", "error").then(function (isConfirm) {
      if (isConfirm.value) {
        // store.dispatch({ type: 'LOGOUT' });
      }
    });
  } else if (err?.response?.status === 500) {
    Sweetalert("Could Not Fetch Data!", "error").then(function (isConfirm) {
      if (isConfirm.value) {
        // store.dispatch({ type: 'LOGOUT' });
      }
    });
  } else if (err?.response?.status === 0) {
    Sweetalert("ERROR CONNECTION TIMED OUT", "error").then(
      function (isConfirm) {
        if (isConfirm.value) {
          // store.dispatch({ type: 'LOGOUT' });
        }
      },
    );
  } else {
    if (
      err.response.data.errorMessage !== null &&
      err.response.data.errorMessage !== undefined &&
      err.response.data.errorMessage.length > 0
    ) {
      let errorMessage = err.response.data.errorMessage;
      Sweetalert(errorMessage, "error");
    } else {
      Sweetalert(
        "Please check your Internet connection and try again.",
        "error",
      );
    }
  }
  dispatch({ type: "HIDE_SPINNER" });
  return "";
};

export const CommonAxiosHttpGet = async (url, xmlData) => {
  let response = null;
  var token = JSON.parse('"' + localStorage.getItem("token") + '"');
  try {
    const res = await axios({
      url: url,
      method: "get",
      headers: {
        "Content-Type": "text/xml",
        //'Access-Control-Allow-Origin': '*', // Add the Access-Control-Allow-Origin header
        Authorization: "Bearer " + token,
      },
      data: xmlData,
    });

    if (res.status === 200) {
      response = res.data;
    }
  } catch (err) { }

  return response;
};

export const CommonAxiosGetsPdf = async (url, values) => {
  let data = "";
  var token = JSON.parse('"' + localStorage.getItem("token") + '"');
  try {
    let res = await axios({
      url: url,
      method: "get",
      // data: values,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/pdf",
      },
    });
    if (res.status === 200 && res !== undefined) {
      data = res;
    }
  } catch (err) {
    catchErrorMessages(err);
  }
  return data;
};

export const WithApiKeysGet = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      data: values,
      headers: {
        "bie-api-key":
          "0ceb290f13e479f0af955a0a0cb437ea3db59d1bbde17540687ece678c03df17",
      },
      //headers: { Authorization: "Bearer " + token }
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const WithApiKeysPost = async (url, values) => {
  try {
    let data = "";
    //var token = JSON.parse(localStorage.getItem("token"));
    //var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "post",
      data: values,
      headers: {
        "bie-api-key":
          "0ceb290f13e479f0af955a0a0cb437ea3db59d1bbde17540687ece678c03df17",
      },
      //headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const PublicCommonAxiosPOST = async (url, values) => {
  let data = "";
  try {
    //var token = JSON.parse(localStorage.getItem("token"));
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "post",
      data: values,
      //headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    //catchErrorMessages(err)

    if (err.response && err.response.status === 401) {
      data = err.response;
    }

    return data;
  }
};
export const PublicResultsCommonAxiosPOST = async (url, values) => {
  let data = "";
  try {
    //var token = JSON.parse(localStorage.getItem("token"));
    let res = await axios({
      baseURL: config.url.API_RESULTS_URL,
      url: url,
      method: "post",
      data: values,
      //headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    //catchErrorMessages(err)

    if (err.response && err.response.status === 401) {
      data = err.response;
    }

    return data;
  }
};

export const CommonAxiosGetNew = async (url, values) => {
  // var token = await getTokenFromLocalStorage('token')
  try {
    let data = "";
    let res = await axios({
      url: url,
      method: "get",
      data: values,
      // headers: { Authorization: "Bearer " + token }
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};
export const getTokenFromLocalStorage = async () => {
  let token = "";
  if (localStorage.getItem("token") === null) {
    // let userId = await fetchDataFromCrossDomainGuest('userId')
    // var userName = await fetchDataFromCrossDomainGuest('userName')
    // var displayName = await fetchDataFromCrossDomainGuest('displayName')
    // localStorage.setItem('userId', userId)
    // localStorage.setItem('userName', userName)
    // localStorage.setItem('displayName', JSON.stringify(displayName))
    // token = await fetchDataFromCrossDomainGuest('token');
    // localStorage.setItem('token', JSON.stringify(token))
  } else {
    // alert(localStorage.getItem('token'))
    token = JSON.parse(localStorage.getItem("token"));
  }
  return token;
};

export const CommonAxiosGetExcel = async (url) => {
  let token = JSON.parse(localStorage.getItem("token"));

  try {
    const res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "get",
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + token,
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });

    return res;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosPostPdfArrayBuffer = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse(localStorage.getItem("token"));
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL,
      url: url,
      method: "post",
      data: values,
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/pdf", // Set the expected Content-Type
      },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosSVAMITVAGet = async (url, values) => {
  var token = JSON.parse(localStorage.getItem("token"));
  // var token = await getTokenFromLocalStorage('token')
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL_SVAMITVA,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosGetSVAMITVAPdf = async (url, values) => {
  //var token =JSON.parse(localStorage.getItem("token"));
  var token = JSON.parse(localStorage.getItem("token"));
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL_SVAMITVA,
      url: url,
      method: "get",
      data: values,
      responseType: "arraybuffer",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "application/pdf", // Set the expected Content-Type
      },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosSVAMITVAPost = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL_SVAMITVA,
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosSWMGet = async (url, values) => {
  var token = JSON.parse(localStorage.getItem("token"));
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.API_URL_SWM,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosSWMPost = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.API_URL_SWM,
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
}

export const CommonAxiosHRMSGet = async (url, values) => {
  var token = JSON.parse(localStorage.getItem("token"));
  // var token = await getTokenFromLocalStorage('token')
  try {
    let data = "";
    let res = await axios({
      baseURL: config.url.HRMS_URL,
      url: url,
      method: "get",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);
  }
};

export const CommonAxiosHRMSPost = async (url, values) => {
  try {
    let data = "";
    var token = JSON.parse(localStorage.getItem("token"));
    // var token = JSON.parse("\"" + localStorage.getItem("token") + "\"");
    let res = await axios({
      baseURL: config.url.HRMS_URL,
      url: url,
      method: "post",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) {
    catchErrorMessages(err);

    // IMPORTANT
    throw err;
  }

};
